import { HttpMethodEnum } from "../data/models/HttpMethodEnum";
import { ApiResponse, RequestBuilder } from "./RequestBuilder";

export class BaseApi {
  protected static requestBuilder = new RequestBuilder();

  protected static createEndpoint<ResponseType, ParamsType>(
    method: HttpMethodEnum,
    url: string
  ) {
    return {
      request: (params: ParamsType, staleTime = 0): Promise<ApiResponse<ResponseType>> =>
        BaseApi.requestBuilder.requestWithCache<ResponseType>(
          method,
          url,
          params,
          staleTime
        ),

      requestHard: (params: ParamsType): Promise<ApiResponse<ResponseType>> =>
        BaseApi.requestBuilder.requestHard<ResponseType>(method, url, params),
    };
  }
}
